import React, { useEffect, useState, useContext } from 'react';
import styled, { ThemeProvider } from 'styled-components';
import ChatBot from 'react-simple-chatbot';
import { CAROL } from '../../constants/chatBot';
import { UserType } from '../../types/user';
import ico from '../../assets/attendantIco.svg'
import "./chat-carol.page.scss";
import { FinalVideoService } from '../../services/final-video.service';
import { UserContext } from '../../components/userContext';
import { LoadVideoBgService } from '../../services/load-video-bg.service';
import { ROTAVIDEOS } from '../../constants/rotas-videos.constant';
import { MaisServicosService } from '../../services/mais-servicos.service';
import { MenuService } from '../../services/menu.service';
import { sendEvent } from '../../scripts/events';

const theme = {
  background: '#f5f8fb',
  fontFamily: 'Helvetica Neue',

  headerBgColor: '#fff',
  headerFontColor: '#2c3a49',
  headerFontSize: '15px',

  botBubbleColor: '#3a6dd8',
  botFontColor: '#fff',

  userBubbleColor: '#93d131',
  userFontColor: '#fff',
};

const optionStyle = {
  backgroundColor: '#93d131',
  display: 'block',
};

const StyledChatBot = styled(ChatBot)`
  .rsc-content {
    height: calc(360px - 60px);
  }

  @media (max-width: 1024px) {
    .rsc-content {
      height: calc(360px - 100px);
    }
  }

  .rsc-footer {
    display: none;
  }
`;

export enum Attendant { Receptionist, Concierge };

export type ChatBotProps = {
  handleClose: ({ command, metadata }: { command: number, metadata?: any }) => void;
  onToggleFloating: () => void;
  user?: UserType;
  attendant: Attendant;
}

const Chat = ({ user, attendant, handleClose, onToggleFloating }: ChatBotProps) => {
  const firstName = user ? (user.name ? user.name.split(' ')[0] : '') : '';

  const talk = (attendant: Attendant) => CAROL;

  const handleEnd = ({ steps, values }: { steps: any, values: [any] }) => {
    const lastAnswer = values.length > 0 ? values[values.length - 1] : undefined;
    let showFirst: number[] = [];

    if (lastAnswer) {
      if (lastAnswer.option === ROTAVIDEOS.lives) {
        sendEvent({ category: 'chat_carol', label: 'lives', action: 'click' });
        LoadVideoBgService.sendNomeVideo(ROTAVIDEOS.lives);
      }

      if (lastAnswer.option === ROTAVIDEOS.maisServicos) {
        sendEvent({ category: 'chat_carol', label: 'mais_servicos', action: 'click' });
        MaisServicosService.send(true);
      }

      if (lastAnswer.option === ROTAVIDEOS.desafios) {
        sendEvent({ category: 'chat_carol', label: 'desafios', action: 'click' });
        MenuService.sendAtivo(true);
      }

      if (lastAnswer.option === ROTAVIDEOS.sobreBayer) {
        sendEvent({ category: 'chat_carol', label: 'sobre', action: 'click' });
        window.open('https://www.agro.bayer.com.br/impulso-bayer/o-programa', '_blank')
      }

      if (lastAnswer.option === ROTAVIDEOS.forum) {
        sendEvent({ category: 'chat_carol', label: 'forum', action: 'click' });
        LoadVideoBgService.sendNomeVideo(ROTAVIDEOS.forum);
      }

      if (lastAnswer.option === ROTAVIDEOS.foxXproPlantacao) {
        sendEvent({ category: 'chat_carol', label: 'fox_xpro', action: 'click' });
        LoadVideoBgService.sendNomeVideo(ROTAVIDEOS.foxXproPlantacao);
      }

      if (lastAnswer.option === ROTAVIDEOS.especialista) {
        sendEvent({ category: 'chat_carol', label: 'especialista', action: 'click' });
        window.open('https://wa.me/5563991374921?text=Ol%C3%A1%20Silvia!%20Vim%20atrav%C3%A9s%20do%20Espa%C3%A7o%20Bayer%20e%20gostaria%20de%20mais%20informa%C3%A7%C3%B5es%20sobre...%20', '_blank')
      }

    }

    handleClose({ command: lastAnswer.option, metadata: { showFirst } });
  };

  return (
    <ThemeProvider theme={theme}>
      <React.StrictMode>
        <StyledChatBot
          handleEnd={handleEnd}
          className={'custom-chat-bot chat-carol ' + talk(attendant).attendant}
          botAvatar={ico}
          headerTitle={talk(attendant).attendant}
          hideSubmitButton={true}
          hideUserAvatar={true}
          botDelay={2000}
          height={'360px'}
          floating={true}
          opened={true}
          steps={talk(attendant).talk}
          bubbleOptionStyle={optionStyle}
          toggleFloating={() => {
            onToggleFloating();
          }}
        />
      </React.StrictMode>
    </ThemeProvider>
  )
}

export default function ChatCarolPage() {

  const [attendant, setAttendant] = useState(Attendant.Receptionist);
  const [showBolinhas, setShowBolinhas] = React.useState<boolean>(false);
  const userProps = useContext(UserContext);

  useEffect(() => {
    FinalVideoService.getFinal().subscribe((nomeVideo: boolean) => {
      if (window.location.href.indexOf('chatCarol') > -1) {
        setShowBolinhas(true);
      }
    });

    document.body.classList.add("page-chat-carol");

    return () => {
      document.body.classList.remove("page-chat-carol");
    }
  }, []);

  return (
    <>
      {showBolinhas && (
        <Chat
          onToggleFloating={() => {
            //props.onCloseX
            LoadVideoBgService.sendNomeVideo(ROTAVIDEOS.home);
          }}
          handleClose={() => {
            //
          }}
          user={userProps.user}
          attendant={attendant} />
      )}
    </>
  );
}
